// src/components/OperatorModal.jsx
import React from 'react'
import { X } from 'lucide-react'

export function OperatorModal({ onClose }) {
  return (
    <div style={{
      position: 'fixed', inset: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 2000,
      padding: '16px',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 16,
        width: '100%',
        maxWidth: 560,
        maxHeight: '85vh',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
      }}>
        {/* ヘッダー */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '20px 24px 16px',
          borderBottom: '1px solid #f3f4f6',
          flexShrink: 0,
        }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, color: '#1a1a2e', margin: 0 }}>
            運営者情報
          </h2>
          <button
            onClick={onClose}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              color: '#6b7280', padding: 4, borderRadius: 6,
              display: 'flex', alignItems: 'center',
            }}
          >
            <X size={20} />
          </button>
        </div>

        {/* コンテンツ */}
        <div style={{
          overflowY: 'auto',
          padding: '20px 24px 28px',
          fontSize: 13,
          lineHeight: 1.85,
          color: '#374151',
        }}>
          {/* 運営者名 */}
          <div style={{ marginBottom: 24, padding: '14px 16px', background: '#f5f3ff', border: '1px solid #ddd6fe', borderRadius: 12 }}>
            <p style={{ margin: 0, fontSize: 13, color: '#6b7280' }}>運営者名</p>
            <p style={{ margin: '4px 0 0', fontSize: 16, fontWeight: 700, color: '#1a1a2e' }}>sens1204</p>
          </div>

          {/* HowToonについて */}
          <Section title="HowToonについて">
            <p style={{ margin: 0 }}>
              当サイト「HowToon」は、sens1204 が個人で企画・開発・運営しているWebサービスです。
            </p>
            <p style={{ margin: '10px 0 0' }}>
              HowToonは、「自分にとっては当たり前でも、誰かにとっては難しいことがある」という考えを出発点に生まれました。
              日常の家事やスマートフォンの使い方、資格の勉強方法、特定の職業への就き方など――
              一人ひとりが持っている経験や知識は、誰かの役に立つ可能性を持っています。
            </p>
            <p style={{ margin: '10px 0 0' }}>
              HowToonは、そうした"知っていること"を気軽に共有できる場所として運営しています。
              身近なことから専門的なことまで幅広いテーマのハウツーが集まり、
              「分からない」に出会ったとき、解決のヒントが見つかる場になることを目指しています。
            </p>
          </Section>

          {/* サイトの基本方針 */}
          <Section title="サイトの基本方針">
            <ul style={{ margin: 0, paddingLeft: 0, listStyle: 'none' }}>
              {[
                '実用性と分かりやすさを大切にします。',
                'ユーザー同士が安心して知識や経験を共有できる環境づくりを心がけます。',
                '利用規約に基づき、円滑なサービス運営に努めます。',
                '個人情報は適切に取り扱い、プライバシーを尊重します。',
              ].map((item, i) => (
                <li key={i} style={{ display: 'flex', gap: 8, marginBottom: 6 }}>
                  <span style={{ color: '#6d28d9', flexShrink: 0, fontWeight: 700 }}>・</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </Section>

          {/* コミュニティについて */}
          <Section title="コミュニティについて">
            <p style={{ margin: 0 }}>
              記事が役に立ったと感じた場合は、ぜひコメントでその気持ちを伝えてみてください。
              「ありがとう」の一言は、執筆者にとって大きな励みになります。
            </p>
            <p style={{ margin: '10px 0 0' }}>
              また、内容に補足や意見、修正点がある場合も歓迎しています。
              ただし、情報を共有してくれた相手への敬意を忘れず、建設的で思いやりのある表現を心がけてください。
            </p>
            <p style={{ margin: '10px 0 0' }}>
              HowToonは、互いの経験や知識を尊重し合いながら成長していく場でありたいと考えています。
            </p>
          </Section>

          {/* お問い合わせ */}
          <Section title="お問い合わせ">
            <p style={{ margin: 0 }}>
              本サービスに関するご意見・お問い合わせは、サイト内に設置しているお問い合わせフォームよりお願いいたします。
            </p>
          </Section>
        </div>
      </div>
    </div>
  )
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 22 }}>
      <h3 style={{ fontSize: 14, fontWeight: 700, color: '#1a1a2e', marginBottom: 8, paddingBottom: 6, borderBottom: '1px solid #f3f4f6' }}>
        {title}
      </h3>
      <div>{children}</div>
    </div>
  )
}
